var map = {
	"./aero-comfort.jpg": 52,
	"./aero-concentrator.jpg": 53,
	"./aero-infusion.jpg": 54,
	"./aero-mattress.jpg": 55,
	"./aero-nebulizer.jpg": 56,
	"./aero-oximeter.jpg": 57,
	"./aero-syringe.jpg": 58,
	"./aero-thermometer.jpg": 59,
	"./aeromed-fistula.jpg": 60,
	"./bicarb-mixing.jpg": 61,
	"./blood-tubing.jpg": 62,
	"./citro-h.jpg": 63,
	"./cold-sterilant.jpg": 64,
	"./comfort-chair.jpg": 65,
	"./diaclean-dialyzer.jpg": 66,
	"./dialysis-chair.jpg": 67,
	"./dialyzer-reprocessor.JPG": 68,
	"./dora-dialyzer.jpg": 69,
	"./dora-dialyzer2.JPG": 70,
	"./extend-xt.jpg": 71,
	"./fresenius-hemodialysis.jpg": 72,
	"./hemodialysis-solution.jpg": 73,
	"./infusion-buret.jpg": 74,
	"./infusion-pedia.jpg": 75,
	"./jms-infusion-500.jpg": 76,
	"./jms-infusion.jpg": 77,
	"./jms-meditape.jpg": 78,
	"./joylife-pedia.jpg": 79,
	"./joylife.png": 80,
	"./monnal-t60-ventilator.jpg": 81,
	"./monnal-t75.jpg": 82,
	"./nikkiso-hemodialysis.jpg": 83,
	"./orion-g-ventilator.jpg": 84,
	"./oxygen-generator.jpg": 85,
	"./sodium-injection.jpg": 86,
	"./sucrose-injection.jpg": 87,
	"./sws-400.jpg": 88,
	"./transducer-protector.jpg": 89,
	"./transfusion-buret.jpg": 90,
	"./transfusion-scalp.jpg": 91,
	"./transfusion-type5.jpg": 92,
	"./transfusion-typeY.jpg": 93,
	"./water-treatment.jpg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;